import { createAction, props } from '@ngrx/store';

import { IRailEmissionCompany, IRailEmissionReport, IRailEmissionRequest } from '@ruby/modules/rail-emission/models/rail-emission.interface';
import { IError } from '@ruby/shared/models/request/error.interface';

export const loadEmissionFilters = createAction(
  '[Rail Emission] Load Emission Filters'
);

export const loadEmissionFiltersSuccess = createAction(
  '[Rail Emission] Load Emission Filters Success',
  props<{ data: Array<IRailEmissionCompany> }>()
);

export const loadEmissionFiltersFailure = createAction(
  '[Rail Emission] Load Emission Filters Failure',
  props<{ error: IError }>()
);

export const loadEmissionReport = createAction(
  '[Rail Emission] Load Emission Report',
  props<{ data: IRailEmissionRequest }>()
);

export const loadEmissionReportSuccess = createAction(
  '[Rail Emission] Load Emission Report Success',
  props<{ data: Array<IRailEmissionReport> }>()
);

export const loadEmissionReportFailure = createAction(
  '[Rail Emission] Load Emission Report Failure',
  props<{ error: IError }>()
);

export const resetState = createAction(
  '[Rail Emission] Reset State'
);

export const auditDownload = createAction(
  '[Rail Emission] Audit Download',
  props<{ data: IRailEmissionRequest }>()
);

export const auditDownloadSuccess = createAction(
  '[Rail Emission] Audit Download Success'
);

export const auditDownloadFailure = createAction(
  '[Rail Emission] Audit Download Failure',
  props<{ error: IError }>()
);
